import { render } from "./TemplateIsoRadioGroup.vue?vue&type=template&id=e2fc236c&scoped=true"
import script from "./TemplateIsoRadioGroup.vue?vue&type=script&lang=js"
export * from "./TemplateIsoRadioGroup.vue?vue&type=script&lang=js"

import "./TemplateIsoRadioGroup.vue?vue&type=style&index=0&id=e2fc236c&lang=less&scoped=true"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2fc236c"]])

export default __exports__